import { useCallback } from "react"
import { observer } from "mobx-react-lite"
import { Button, ButtonProps } from "@fluentui/react-button"
import { ArrowClockwiseRegular } from '@fluentui/react-icons'
import { GenericList } from "@knowmax/genericlist-core"

type IProps<T = unknown> = {
  list: GenericList<T>
} & ButtonProps

/** Renders button to refresh/reload the list data. */
export const RefreshList = observer(<T = unknown>(props: IProps<T>) => {
  const { list, ...buttonProps } = props

  const refresh = useCallback(() => {
    list.setPage(1)
    list.load(true)
  }, [list])

  return (
    <Button {...buttonProps} icon={buttonProps.icon || <ArrowClockwiseRegular />} onClick={refresh} />
  )
})
